export default __webpack_public_path__ + "static/media/1-mobile-popup-image-promo-app.486d2e35.png";